import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import DoubleArrowBack from '../svgComponents/doubleArrowBack'
import DoubleArrowNext from '../svgComponents/doubleArrowNext'
import OneArrowBack from '../svgComponents/oneArrowLeft'
import OneArrowNext from '../svgComponents/oneArrowRight'

const DOUBLE_ARROW_LEFT = "double-arrow-left"
const DOUBLE_ARROW_RIGHT = "double-arrow-right"
const ONE_ARROW_LEFT = "one-arrow-left"
const ONE_ARROW_RIGHT = "one-arrow-right"
const PaginationLink = (props) => {
  const { getPage, pageNumber, glyphType, active, disabled } = props

  const handleClick = (pageNumber, onClickEvent, event) => {
    event.preventDefault()
    onClickEvent(pageNumber)
  }

  const paginationClass = classNames('pagination-item', {
    'pagination-arrow': glyphType,
    active,
    disabled,
  })

  const paginationContent = (glyph = glyphType, number = pageNumber) => {

    if (!glyph) {
      return number
    }

    switch(glyph) {
      case DOUBLE_ARROW_LEFT:
      return <DoubleArrowBack />

      case DOUBLE_ARROW_RIGHT:
        return <DoubleArrowNext />


      case ONE_ARROW_LEFT:
        return <OneArrowBack />


      case ONE_ARROW_RIGHT:
        return <OneArrowNext />


      default:
        return number
    }
  }

  if (disabled || active) {
    return (
      <span
        className={paginationClass}
        title={`Página ${pageNumber}`}
        disabled={disabled}
      >
        {paginationContent()}
      </span>
    )
  }

  return (
    <a
      href={`?page=${pageNumber}`}
      onClick={(event) => handleClick(pageNumber, getPage, event)}
      className={paginationClass}
      title={`Página ${pageNumber}`}
      disabled={disabled}
    >
      {paginationContent()}
    </a>
  )
}

PaginationLink.propTypes = {
  getPage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  glyphType: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default PaginationLink
